import { string } from 'prop-types';
import { StyledLink } from 'src/components/common/styledComponents/styledLink';

const EmailLink = ({ email }) => (
  <StyledLink className="email-link" href={`mailto:${email}`}>
    {email}
  </StyledLink>
);

EmailLink.propTypes = {
  email: string,
};

export { EmailLink };
